<template>
    <span>
        {{ t == 1 ? '【单选】':(t == 2 ? '【多选】' : '【不定项】') }}
    </span>
</template>

<script>
    export default {
        name: 'TopicType',
        props: {
            t:{
                type: Number,
                default:1
            },
        },
    }
</script>

